import { render, staticRenderFns } from "./ReferralServiceInventoryItem.vue?vue&type=template&id=0f1bfb7c&scoped=true"
import script from "./ReferralServiceInventoryItem.vue?vue&type=script&lang=js"
export * from "./ReferralServiceInventoryItem.vue?vue&type=script&lang=js"
import style0 from "./ReferralServiceInventoryItem.vue?vue&type=style&index=0&id=0f1bfb7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1bfb7c",
  null
  
)

export default component.exports